import React from 'react';
import propTypes from 'prop-types';

import style from './index.less';
import { i18n } from '../../unit/const';

export default class Logo extends React.Component {
  constructor() {
    super();
    this.state = {
      display: 'none',
    };
  }
  UNSAFE_componentWillMount() {
    this.animate(this.props);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (
        [this.props.cur, nextProps.cur].indexOf(false) !== -1 &&
        (this.props.cur !== nextProps.cur)
      ) ||
      (this.props.reset !== nextProps.reset)
    ) {
      this.animate(nextProps);
    }
  }
  shouldComponentUpdate({ cur, reset, lan }) {
    return cur !== this.props.cur || reset !== this.props.reset || !cur || lan !== this.props.lan;
  }
  animate({ cur, reset }) {
    clearTimeout(Logo.timeout);
    this.setState({ display: 'none' });
    if (cur || reset) {
      return;
    }

    const show = (func) => {
      Logo.timeout = setTimeout(() => {
        this.setState({ display: 'block' });
        if (func) func();
      }, 150);
    };

    const hide = (func) => {
      Logo.timeout = setTimeout(() => {
        this.setState({ display: 'none' });
        if (func) func();
      }, 150);
    };

    const run = () => {
      show(() => {
        hide(() => {
          show(() => {
            hide(() => {
              show();
            });
          });
        });
      });
    };

    run();
  }
  render() {
    if (this.props.cur) {
      return null;
    }
    return (
      <div className={style.logo} style={{ display: this.state.display }}>
        <p dangerouslySetInnerHTML={{ __html: i18n.titleCenter[this.props.lan] }} />
      </div>
    );
  }
}

Logo.propTypes = {
  cur: propTypes.bool,
  reset: propTypes.bool.isRequired,
  lan: propTypes.string.isRequired,
};
Logo.statics = {
  timeout: null,
};
